const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif', color: '#333' }}>
      <h2>Política de Privacidad de ConecTlajo</h2>
      <p><strong>Última actualización:</strong> 17 de abril de 2025</p>

      <h3>1. Responsable del Tratamiento de Datos</h3>
      <p>La presente política de privacidad aplica a la aplicación <strong>ConecTlajo</strong>, desarrollada por <strong>Enigma Tech</strong>, contacto: contacto@enigmatech.io.</p>
      <p>Enigma Tech es responsable del tratamiento de los datos personales recopilados a través de la aplicación móvil ConecTlajo.</p>

      <h3>2. Datos Personales que Recopilamos</h3>
      <p>Al utilizar ConecTlajo, podemos recopilar los siguientes datos personales de los usuarios:</p>
      <ul>
        <li><strong>Datos de identidad:</strong></li>
        <li style={{ marginLeft: '1rem' }}>Nombre completo</li>
        <li style={{ marginLeft: '1rem' }}>Correo electrónico</li>
        <li style={{ marginLeft: '1rem' }}>Número de teléfono</li>
        <li><strong>Datos de ubicación:</strong></li>
        <li style={{ marginLeft: '1rem' }}>Geolocalización en tiempo real mientras se genera un reporte ciudadano</li>
        <li><strong>Datos multimedia:</strong></li>
        <li style={{ marginLeft: '1rem' }}>Fotografías y videos capturados desde la cámara del dispositivo o seleccionados desde la galería</li>
        <li><strong>Datos técnicos:</strong></li>
        <li style={{ marginLeft: '1rem' }}>Tipo de dispositivo, sistema operativo, versión de la app, entre otros datos con fines de diagnóstico y soporte técnico</li>
      </ul>

      <h3>3. Finalidades del Tratamiento de Datos</h3>
      <p>Los datos recopilados se utilizan con las siguientes finalidades:</p>

      <h4>Finalidades primarias</h4>
      <ul>
        <li>Crear, autenticar y gestionar cuentas de usuario dentro de la plataforma</li>
        <li>Permitir la generación de reportes ciudadanos con evidencia visual y coordenadas geográficas</li>
        <li>Asociar imágenes y ubicación precisa a los reportes generados</li>
        <li>Permitir al usuario personalizar su perfil mediante la carga de un avatar</li>
        <li>Comunicarse con el usuario para confirmar reportes o proporcionar actualizaciones</li>
      </ul>

      <h4>Finalidades secundarias (previo consentimiento)</h4>
      <ul>
        <li>Mejorar la calidad del servicio a través de análisis de uso de la aplicación</li>
        <li>Enviar notificaciones relacionadas con funcionalidades o actualizaciones importantes de la app</li>
      </ul>

      <h3>4. Uso de Permisos del Dispositivo</h3>
      <ul>
        <li><strong>Ubicación (geolocalización):</strong> utilizada exclusivamente para asignar coordenadas al reporte que el usuario genera.</li>
        <li><strong>Cámara y galería:</strong> utilizadas para adjuntar fotografías o videos como evidencia visual del reporte, o para actualizar el avatar de perfil del usuario.</li>
      </ul>
      <p>Estos permisos no son utilizados para ningún otro fin y el acceso se solicita de forma explícita y granular dentro de la app.</p>

      <h3>5. Conservación de los Datos</h3>
      <p>Los datos personales serán conservados durante el tiempo que el usuario mantenga una cuenta activa en ConecTlajo. Una vez eliminada la cuenta, los datos se eliminarán de forma segura, salvo disposición legal en contrario.</p>

      <h3>6. Eliminación de Cuenta</h3>
      <p>El usuario podrá solicitar la eliminación total de su cuenta directamente desde la app. Esta acción eliminará todos los datos personales asociados, información de perfil e historial.</p>

      <h3>7. Transferencia de Datos</h3>
      <p>No compartimos, vendemos ni transferimos datos personales a terceros, salvo cuando sea necesario para cumplir con una obligación legal o con el consentimiento expreso del usuario.</p>

      <h3>8. Derechos ARCO</h3>
      <p>El usuario tiene derecho a:</p>
      <ul>
        <li>Rectificar datos inexactos</li>
        <li>Cancelar sus datos cuando ya no sean necesarios</li>
        <li>Oponerse al tratamiento de sus datos en determinadas circunstancias</li>
        <li>Eliminación de sus datos</li>
      </ul>
      <p>Para ejercer estos derechos, puede enviar una solicitud a: <strong>datos@enigmatech.mx</strong>, desde la aplicación o a través del siguiente enlace:</p>
      <p>
        <a href="https://cercania.tlajomulco.gob.mx/support" rel="noopener noreferrer" target="_blank">
          https://cercania.tlajomulco.gob.mx/support
        </a>
      </p>

      <h3>9. Seguridad de la Información</h3>
      <p>Enigma Tech implementa medidas técnicas, administrativas y físicas para proteger los datos personales contra daño, pérdida, alteración, destrucción, uso o acceso no autorizado.</p>

      <h3>10. Cambios en la Política de Privacidad</h3>
      <p>Esta política puede ser modificada en el futuro. Cualquier cambio será notificado a través de la aplicación y/o al correo electrónico registrado. En casos donde se requiera un nuevo consentimiento, éste será solicitado explícitamente.</p>

      <h3>11. Contacto</h3>
      <p>Si tienes dudas o comentarios respecto a esta política, puedes contactarnos en:</p>
      <p><strong>Enigma Tech</strong></p>
      <p>contacto@enigmatech.io</p>
    </div>
  )
}
export default PrivacyPolicy
